import React, { useRef, useState, useEffect } from "react";
import { setStorage, getStorage, deleteStorage } from "../modals/Storage";
import { API_ACCESS_URL } from "../modals/Constants";
import { Link, useNavigate } from "react-router-dom";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import BottomNavbar from "../other-components/BottomNavbar/Navbar";
import general from "../css/General.module.css";

function Trading() {
    const navigate = useNavigate();
    const toastDialogRef = useRef(null);
    const [isLoadingShow, setLoadingShow] = useState(false);

    const [pageConst, setConstants] = useState({
        accountId: "",
        accountBalance: 0,
        isDataLoaded: false,
        recordList: [],
    });

    const [noticeDialogConst, setNoticeDialogConst] = useState({
        noticeTitle: "",
        noticeNote: "",
        noticeDialogShow: false,
    });

    const signOutAccount = () => {
        if (deleteStorage()) {
            navigate("/login", { replace: true });
        }
    };

    // toast component
    const onToastChange = (data, msg) => { };

    const showToast = (message, duration, delay, mode) => {
        toastDialogRef.current.openDialog(message, duration, delay, mode);
    };

    function getTradeList() {
        const fecthApiData = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Route: "route-trade-options",
                        AuthToken: getStorage("secret"),
                    },
                    body: JSON.stringify(formData),
                });
                const data = await res.json();
                setLoadingShow(false);

                if (data.status_code == "success") {
                    setStorage("balance", data.balance);
                    setStorage("wbalance", data.withdrawal_balance);

                    setConstants({
                        ...pageConst,
                        recordList: data.data
                    });
                } else if (data.status_code == "authorization_error") {
                    signOutAccount();
                }
            } catch (error) {
                setLoadingShow(false);
            }
        };

        if (!isLoadingShow) {
            setLoadingShow(true);

            const formData = {
                ACCOUNT_ID: getStorage("uid")
            };
            fecthApiData(API_ACCESS_URL, formData);
        }
    }

    useEffect(() => {
        if (!getStorage("uid")) {
            signOutAccount();
        } else {
            getTradeList();
        }
    }, []);

    return (
        <div className={[general.appContents].join(" ")}>
            <LoadingDialog intentData={isLoadingShow} />

            <div
                className={[
                    general.height100vh,
                    general.respWidth,
                    general.overflowScrollY,
                    general.appContentsBackground,
                    general.hideScrollBar,
                ].join(" ")}
            >
                <div className="w-100 ps-sticky ps-tp row-view pd-10-15 z-i-90 bg-custom-1">
                    <div className="col-view">
                        <p className="ft-sz-22 cl-white">Trading</p>
                        <div className="row-view">
                            <p className="ft-sz-16 cl-green">Profit: ₹{getStorage("wbalance")}</p>
                            <p className="ft-sz-16 cl-l-white mg-l-15">Balance: ₹{getStorage("balance")}</p>
                        </div>
                    </div>
                </div>

                <div className="pd-15 mg-t-10 bg-custom-1">
                    {pageConst.recordList.map((item, index) => {
                        return (
                            <div className={`w-100 row-view sb-view ${index > 0 ? 'mg-t-25' : ''}`} key={item.id}>
                                <div className="row-view">
                                    <img
                                        src={item.icon}
                                        className="h-w-45"
                                        alt="icon"
                                    />
                                    <div className="mg-l-20">
                                        <p className="cl-white ft-sz-18">{item.title}</p>
                                        <p className="cl-l-white ft-sz-15">Price: ₹{item.price}</p>
                                    </div>
                                </div>

                                <Link className="txt-deco-n v-center ft-sz-17 pd-10-20 cl-white br-5 bg-selected" to={"/trade?id=" + item.id}>Trade</Link>
                            </div>
                        )
                    })}
                </div>

                <BottomNavbar activeBar="trading" />

            </div>
        </div>
    );
}

export default Trading;